import React, { Suspense, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import TopBar from "./topbar/components/TopBar";
import TopBarLogo from "./topbar/components/TopBarLogo";
import SideBar from "features/shared/layout/sidebar/components/Sidebar";
import DeviceTypeEnum from "features/shared/enums/DeviceTypeEnum";
import styles from "./layout.module.scss";
import SidebarMenuItem from "./sidebar/models/SidebarMenuItem";
import ProfileDialog from "./profile/components/ProfileDialog";
import Content from "./content/Content";
import ISidebarService from "./sidebar/services/ISidebarService";
import IRepository from "data/IRepository";
import CustomerSimplifiedDTO from "features/customer/dtos/CustomerSimplifiedDTO";
import { Customer_GetSimplified } from "data/endpoints";
import PagedDataResultDTO from "features/shared/dtos/PagedDataResultDTO";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import PromiseLoadingSpinner from "../components/loaders/PromiseLoadingSpinner";
import ContentDialog from "../components/contentDialog/ContentDialog";
import IDataService from "data/IDataService";
import { getPaginationDefaults } from "../helpers/queryParams";
import LoadingSpinner from "../components/loaders/LoadingSpinner";

interface IProps {
  sidebarItems: SidebarMenuItem[];
}

const Layout: React.FC<IProps> = (props) => {
  // DI
  const dataService = useInjection<IDataService>(IocTypes.DataService);
  const sidebarService = useInjection<ISidebarService>(IocTypes.SidebarService);
	const customerRepo = useInjection<IRepository<CustomerSimplifiedDTO>>(IocTypes.Repository);

  // state
  const [profileDialogShow, setProfileDialogShow] = useState(false);
  const [customers, setCustomers] = useState<PagedDataResultDTO<CustomerSimplifiedDTO>>({result: [], count: 0});

  // side effects
  useEffect(() => {
    if (profileDialogShow) {
      dataService.fetchAndSetPagedResult<CustomerSimplifiedDTO>(customerRepo, setCustomers, Customer_GetSimplified, undefined, getPaginationDefaults(4))
    }
  }, [profileDialogShow]);

  // helpers
  const currentCardId = sidebarService.getCurrentCardIdByRoute(
    useLocation().pathname,
    props.sidebarItems
  );

  // render
  return (
    <>
      <TopBarLogo type={DeviceTypeEnum.MOBILE} />
      <TopBar
        setProfileDialogShow={setProfileDialogShow}
      />

      <div className={styles.pageContainer}>
        <SideBar
          items={props.sidebarItems}
          activeCardId={currentCardId}
        />

        <Content>
          <Suspense fallback={<LoadingSpinner />}>
            <div>{props.children}</div>
            <PromiseLoadingSpinner delay={100} />
          </Suspense>
        </Content>
      </div>

      <ProfileDialog
        show={profileDialogShow}
        setShow={setProfileDialogShow}
        customers={customers.result}
        customersCount={customers.count}
      />
      <ContentDialog />
    </>
  );
};

export default Layout;